var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5001V7.73328",
    stroke: "#FF4040",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37685 12.9111C4.13554 12.6695 4 12.342 4 12.0005C4 11.6591 4.13554 11.3315 4.37685 11.0899L11.0898 4.37768C11.2093 4.25796 11.3511 4.16298 11.5073 4.09817C11.6635 4.03336 11.831 4 12.0001 4C12.1692 4 12.3366 4.03336 12.4928 4.09817C12.649 4.16298 12.7909 4.25796 12.9103 4.37768L19.6233 11.0899C19.8646 11.3315 20.0001 11.6591 20.0001 12.0005C20.0001 12.342 19.8646 12.6695 19.6233 12.9111L12.9103 19.6234C12.6688 19.8646 12.3414 20.0002 12.0001 20.0002C11.6587 20.0002 11.3313 19.8646 11.0898 19.6234L4.37685 12.9111Z",
    stroke: "#FF4040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 1,
    fill: "#FF4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.e63dc9c6.svg";
export { ForwardRef as ReactComponent };